export const tryParseFloat = (value) => {
  const parsed = parseFloat(value);
  return isNaN(parsed) ? null : parsed;
};
